
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppButton } from '@/components';
import useSubscription from '@/modules/subscription/item/model/detail';
import { formatDate, renderTimeUnit } from '@/common/utils/helpers';
import { ROUTE_NAME_SUBSCRIPTION } from '@/modules/subscription/router';

export default defineComponent({
    name: ROUTE_NAME_SUBSCRIPTION.DETAIL,
    components: { AppCard, AppButton },
    setup() {
        const { model, fetch, remove } = useSubscription();

        onMounted(async () => {
            await fetch();
        });

        return { model, formatDate, renderTimeUnit, remove, ROUTE_NAME_SUBSCRIPTION };
    }
});
